import { Box, styled } from '@mui/material';

const ColorBox = styled(Box)`
  background: ${({ theme, color }) => color || theme.palette.grey[300]};
  width: 15px;
  height: 15px;
`;

export default ColorBox;
